import { Auth0Client } from '@auth0/auth0-spa-js';
import {
  AUTH0_AUDIENCE,
  AUTH0_CLIENT_DOMAIN,
  AUTH0_CLIENT_ID,
} from '../common/constants/env.constants';

const auth0 = new Auth0Client({
  domain: AUTH0_CLIENT_DOMAIN,
  clientId: AUTH0_CLIENT_ID,
  useRefreshTokens: true,
  cacheLocation: 'localstorage',
  authorizationParams: {
    redirect_uri: globalThis.location.origin + '/auth-callback',
    audience: AUTH0_AUDIENCE,
  },
});
export default auth0;
